import { useTranslation } from "react-i18next";

import { showModal } from "../../../../../store/slices/modalSlice";
import { Room } from "../../../../../store/slices/roomsSlice";
import { Deck } from "../../../../../store/slices/searchSlice";
import { useTypedDispatch, useTypedSelector } from "../../../../../store/store";
import MODAL from "../../../../../utils/constants/modal";
import { parseMarkdownWithLink } from "../../../../../utils/helpers/parseMarkdown";
import LoadingContainer from "../../../../containers/LoadingContainer";
import Button from "../../../../shared/Button";
import CustomSelect from "../../../../shared/CustomSelect";

import styles from "./index.module.scss";

interface IDeckPlansProps {
  room?: Room;
  decks?: Array<{ value: string; label: string }>;
  handleChoseDeck: (room: Room) => void;
}

function DeckPlans({ room, decks, handleChoseDeck }: IDeckPlansProps) {
  const dispatch = useTypedDispatch();
  const { t } = useTranslation();

  const { cruise } = useTypedSelector((state) => state.search);
  const { isCabinsLoading, cabins } = useTypedSelector((state) => state.rooms);

  const { full_deck_plan_link, deck_legend } = useTypedSelector(
    (state) => state.environment,
  );

  const fullDeckPlan = parseMarkdownWithLink(full_deck_plan_link)[0];

  const handleDeckChange = ({ value }: { value: string }) => {
    const deck: Deck | undefined = cruise?.ship.decks.find(
      (el) => el.code === value,
    );

    const updatedStateroom = structuredClone({ ...room, deck });

    handleChoseDeck(updatedStateroom);
  };

  const showDeckPlansModal = () => {
    dispatch(
      showModal({
        size: "lg",
        type: MODAL.MODAL_TYPES.DECK_PLANS,
        data: fullDeckPlan?.url,
      }),
    );
  };

  return (
    <LoadingContainer isLoading={isCabinsLoading}>
      <div className={styles.container}>
        <div>
          <p className={styles.title}>{t("deck plans")}</p>

          {fullDeckPlan?.text && fullDeckPlan?.url && (
            <Button
              className={styles.fullDeckTitle}
              label={fullDeckPlan?.text}
              variant="link"
              onClick={showDeckPlansModal}
            />
          )}
        </div>

        {cabins?.length ? (
          <div className={styles.selectContainer}>
            <CustomSelect
              className={styles.select}
              label={t("choose a deck")}
              placeholder={t("select a deck")}
              value={room?.deck?.code ?? ""}
              items={decks ?? []}
              onChange={handleDeckChange}
            />

            {room?.deck?.images[0] && (
              <img src={room?.deck?.images[0] ?? ""} alt={t("deck")} />
            )}

            {deck_legend && (
              <img
                className={styles.deckImage}
                src={deck_legend}
                alt="deck legend"
              />
            )}
          </div>
        ) : (
          <p>
            {t(
              "This cabin category has been sold out. Please choose another cabin category",
            )}
          </p>
        )}
      </div>
    </LoadingContainer>
  );
}

export default DeckPlans;
